import type { TUploadMeta } from '../../UploadProvider/types/TUploadMeta';
import type { TRemoveOptions } from '../types/TRemoveOptions';

export const handleRemove = async (arg: {
  meta: TUploadMeta;
  onRemoveRemote?: (meta: TUploadMeta) => Promise<void> | void;
  removeLocal: (id: string, opts?: TRemoveOptions) => void;
  removeOptions?: TRemoveOptions;
}) => {
  const { meta, onRemoveRemote, removeLocal, removeOptions } = arg;
  try {
    if (onRemoveRemote) {
      await onRemoveRemote(meta);
    }
    removeLocal(meta.id, removeOptions);
  } catch (e) {
    console.error('Failed to remove remotely:', e);
  }
};
